<crm-form-loading-indicator [loadingStatus]="loadingStatus">
  <form class="crm-model-driven-form crm-panel-form" form-content [formGroup]="formGroup">
    <mat-accordion [multi]="true">
      @for (renderableFieldGroup of renderableFieldGroups; track renderableFieldGroup) {
        <mat-expansion-panel
          [expanded]="
            isPanelExpanded(
              renderableFieldGroup?.description ?? this.translateService.instant('OBJECT_TYPES.CUSTOM_FIELDS')
            )
          "
          (opened)="
            onPanelOpened(
              renderableFieldGroup?.description ?? this.translateService.instant('OBJECT_TYPES.CUSTOM_FIELDS')
            )
          "
          (closed)="
            onPanelClosed(
              renderableFieldGroup?.description ?? this.translateService.instant('OBJECT_TYPES.CUSTOM_FIELDS')
            )
          "
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ renderableFieldGroup?.description ?? 'OBJECT_TYPES.CUSTOM_FIELDS' | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          @for (renderableField of renderableFieldGroup.fields; track renderableField) {
            <crm-renderer-selector [handler]="renderableField"></crm-renderer-selector>
          }
        </mat-expansion-panel>
      }
    </mat-accordion>
    @for (renderableFieldGroup of readonlyRenderableFieldGroups; track renderableFieldGroup) {
      @for (renderableField of renderableFieldGroup.fields; track renderableField) {
        <crm-renderer-selector [handler]="renderableField"></crm-renderer-selector>
      }
    }
    @if (!readOnly && !inlineEdit) {
      <div class="crm-panel-button-container">
        <crm-form-button-group
          [submitButtonText]="submitButtonText | translate"
          [cancelButtonText]="cancelButtonText | translate"
          [savingStatus]="savingStatus"
          (clickedOnSubmit)="onSubmit()"
          (clickedOnCancel)="onCancel()"
        ></crm-form-button-group>
      </div>
    }
  </form>
</crm-form-loading-indicator>
